module.exports = __webpack_public_path__ + "img/整合营销_3@2x.fea96f43.png";